import { useEvent, useStore, useStoreMap } from 'effector-react'
import {
    $basketPrescriptionPositions,
    $isBasketPrescription,
    $isDelivery,
    onBasketPageMount,
    onBasketPageUnmount,
    toggleIsDelivery
} from 'src/pages/order/basket/model'
import { $prescriptionLimits } from '@entities/prescription/model'

export const useIsDelivery = () => useStore($isDelivery)
export const useToggleIsDelivery = () => useEvent(toggleIsDelivery)
export const useIsBasketPrescription = () => useStore($isBasketPrescription)
export const useIsBasketPrescriptionPositions = () =>
    useStoreMap($basketPrescriptionPositions, (goods) => goods && goods.length > 0)

export const useBasketPageMount = () => useEvent(onBasketPageMount)
export const useBasketPageUnmount = () => useEvent(onBasketPageUnmount)

export const usePrescriptionCupMax = () => useStoreMap($prescriptionLimits, (limits) => limits?.maxPartsSum)
